document.addEventListener('alpine:init', () => {
  Alpine.data('postCarousel', (config = {}) => ({
    // Configuration
    autoplay: config.autoplay ?? true,
    interval: config.interval ?? 5000,
    show_arrows: config.show_arrows ?? true,
    
    // State
    currentSlide: 0,
    totalSlides: 0,
    cardsPerView: 3, // Show 3 cards at a time
    maxSlides: 0,
    slideWidth: 0,
    isTransitioning: false,
    autoPlayInterval: null,
    isPaused: false,
    showArrows: true,
    // Touch support
    startX: 0,
    currentX: 0,
    isDragging: false,
    
    // Initialize
    init() {
      this.slideElements = [...this.$el.querySelectorAll('[data-carousel-slide]')];
      this.slides = this.$el.querySelector('[data-carousel-slides]');
      this.totalSlides = this.slideElements.length;
      
      if (this.totalSlides === 0) return;
      
      this.calculateDimensions();
      this.updateSlidePosition(false);
      
      if (this.autoplay && this.totalSlides > 1) {
        this.startAutoPlay();
      }
      
      // Pause on hover
      this.$el.addEventListener('mouseenter', () => this.pauseAutoPlay());
      this.$el.addEventListener('mouseleave', () => this.resumeAutoPlay());
      
      // Handle resize
      window.addEventListener('resize', this.debounce(() => {
        this.calculateDimensions();
        this.updateSlidePosition(false);
      }, 250));
      
      // Touch support
      this.initTouchSupport();
      
      // Handle transition end
      this.slides.addEventListener('transitionend', () => {
        this.isTransitioning = false;
      });
    },
    
    
    calculateDimensions() {
      if (this.totalSlides === 0) return;
      
      // Update cards per view based on screen size
      const containerWidth = window.innerWidth;
      if (containerWidth <= 800) {
        this.cardsPerView = 1;
      } else if (containerWidth <= 1024) {
        this.cardsPerView = 2;
      } else {
        this.cardsPerView = 3;
      }
      
      // Get the track container width
      const container = this.$el.querySelector('.c-post-carousel__track');
      
      // On mobile, force slideWidth to be full container width (no padding on mobile)
      if (containerWidth <= 800) {
        this.slideWidth = container.offsetWidth;
      } else {
        // On tablet/desktop, calculate based on actual slide element
        const slideElement = this.slideElements[0];
        if (slideElement) {
          this.slideWidth = slideElement.offsetWidth;
          
          // Add gap
          const slidesContainer = this.slides;
          const slidesStyles = window.getComputedStyle(slidesContainer);
          const gap = parseInt(slidesStyles.gap || slidesStyles.columnGap || 0);
          this.slideWidth += gap;
        }
      }
      
      // Calculate max slides (how many groups we can show)
      this.maxSlides = Math.max(0, Math.ceil(this.totalSlides / this.cardsPerView) - 1);
      
      // Update arrow visibility
      this.updateArrowVisibility();
      
      console.log('Carousel dimensions:', {
        containerWidth,
        cardsPerView: this.cardsPerView,
        totalSlides: this.totalSlides,
        maxSlides: this.maxSlides,
        slideWidth: this.slideWidth,
        containerOffsetWidth: container.offsetWidth,
        showArrows: this.showArrows
      });
    },
    
    updateArrowVisibility() {
      const containerWidth = window.innerWidth;
      
      if (containerWidth <= 800) {
        // Mobile: hide if 1 or less slides
        this.showArrows = this.totalSlides > 1;
      } else {
        // Desktop: hide if 3 or less slides
        this.showArrows = this.totalSlides > 3;
      }
    },
    
    shouldShowArrows() {
      return this.showArrows;
    },
    
    initTouchSupport() {
      this.$el.addEventListener('touchstart', (e) => {
        this.startX = e.touches[0].clientX;
        this.isDragging = true;
        this.pauseAutoPlay();
      });
      
      this.$el.addEventListener('touchmove', (e) => {
        if (!this.isDragging) return;
        this.currentX = e.touches[0].clientX;
        e.preventDefault();
      });
      
      this.$el.addEventListener('touchend', () => {
        if (!this.isDragging) return;
        
        const diffX = this.startX - this.currentX;
        const threshold = 50;
        
        if (Math.abs(diffX) > threshold) {
          if (diffX > 0) {
            this.nextSlide();
          } else {
            this.prevSlide();
          }
        }
        
        this.isDragging = false;
        this.resumeAutoPlay();
      });
    },
    
    nextSlide() {
      if (this.isTransitioning) return;
      
      // Allow sliding even if totalSlides equals cardsPerView on mobile
      if (this.totalSlides <= 1) return;
      
      // Wrap around to beginning
      this.currentSlide = this.currentSlide + 1;
      if (this.currentSlide > this.totalSlides - this.cardsPerView) {
        this.currentSlide = 0;
      }
      
      this.updateSlidePosition();
      this.resetAutoPlay();
    },
    
    prevSlide() {
      if (this.isTransitioning) return;
      
      // Allow sliding even if totalSlides equals cardsPerView on mobile
      if (this.totalSlides <= 1) return;
      
      // Wrap around to end
      this.currentSlide = this.currentSlide - 1;
      if (this.currentSlide < 0) {
        this.currentSlide = this.totalSlides - this.cardsPerView;
      }
      
      this.updateSlidePosition();
      this.resetAutoPlay();
    },
    
    goToSlide(index) {
      if (this.isTransitioning || this.totalSlides <= 1) return;
      
      this.currentIndex = index + 1; // Account for cloned slide
      this.updateSlidePosition();
      this.resetAutoPlay();
    },
    
    updateSlidePosition(animate = true) {
      if (!this.slides) return;
      
      // Use the slideWidth calculated in calculateDimensions
      const translateX = -this.currentSlide * this.slideWidth;
      
      if (animate) {
        this.slides.style.transition = 'transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        this.isTransitioning = true;
      } else {
        this.slides.style.transition = 'none';
        this.isTransitioning = false;
      }
      
      this.slides.style.transform = `translateX(${translateX}px)`;
    },
    
    
    startAutoPlay() {
      if (!this.autoplay || this.totalSlides <= 1) return;
      
      this.autoPlayInterval = setInterval(() => {
        if (!this.isPaused) {
          this.nextSlide();
        }
      }, this.interval);
    },
    
    pauseAutoPlay() {
      this.isPaused = true;
    },
    
    resumeAutoPlay() {
      this.isPaused = false;
    },
    
    resetAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
      if (this.autoplay && this.totalSlides > 1) {
        this.startAutoPlay();
      }
    },
    
    // Get current dot index for display
    get currentDotIndex() {
      const realIndex = this.currentIndex - 1;
      if (realIndex < 0) return this.totalSlides - 1;
      if (realIndex >= this.totalSlides) return 0;
      return realIndex;
    },
    
    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    },
    
    destroy() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
      }
    }
  }));
});
